import { render, staticRenderFns } from "./OtpLegend.vue?vue&type=template&id=0e93b7ca&scoped=true"
import script from "./OtpLegend.vue?vue&type=script&lang=js"
export * from "./OtpLegend.vue?vue&type=script&lang=js"
import style0 from "./OtpLegend.vue?vue&type=style&index=0&id=0e93b7ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e93b7ca",
  null
  
)

export default component.exports